// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6025":"css/admin-app.6646","9935":"css/app.6646"}[chunkId] + ".css";
};